import script from "./AppButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=586257dc&lang=scss"

const __exports__ = script;

export default __exports__